// extracted by mini-css-extract-plugin
module.exports = {"back-to-top-container":"styles_back-to-top-container__9TuCW"};